// extracted by mini-css-extract-plugin
export default {"outlet":"layout_outlet__Zomo8"};